const customPhotoInput = document.getElementById("custom_photo");
const customPhotobtn = document.querySelectorAll(".upload-label")[1];
const submitButton = document.querySelector('button[type="submit"]');

setTimeout(() => {
  document.querySelectorAll('input[name="quantity"]').forEach((radio) => {
    radio.addEventListener("change", function () {
      // Remove background color from all .quantity-options
      document.querySelectorAll(".quantity-options").forEach((option) => {
        option.style.background = "none";
      });

      // Add background color to the selected .quantity-options
      if (this.checked) {
        this.closest(".quantity-options").style.background = "#ececec";
      }
    });

    // Check if this radio button is already checked and apply background color
    if (radio.checked) {
      radio.closest(".quantity-options").style.background = "#ececec";
    }
  });
}, 2000);

setTimeout(() => {
  document
    .querySelector(".size-dropdown")
    .addEventListener("click", function () {
      const sizeOptions = document.getElementById("size-options");
      sizeOptions.style.display =
        sizeOptions.style.display === "block" ? "none" : "block";
    });

  // Handle radio button selection and update dropdown

  document
    .querySelectorAll('input[name="dimensions"]')
    .forEach(function (radio) {
      function handleEvent() {
        const selectedValue = this.closest("label").textContent.trim();
        document.querySelector(".size-dropdown").textContent = selectedValue;
        document.getElementById("size-options").style.display = "none";
      }

      // Apply both 'change' and 'click' event listeners
      radio.addEventListener("change", handleEvent);
      radio.addEventListener("click", handleEvent);
    });

  const firstSelectedValue = document
    .querySelector('input[name="dimensions"]:checked')
    .closest("label")
    .textContent.trim();
  document.querySelector(".size-dropdown").textContent = firstSelectedValue;
}, 3000);

function getVariantFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  const variant = urlParams.get("variant");
  if (variant) {
    return parseInt(variant);
  } else {
    var firstvarient = document
      .querySelector("[var-id]")
      .getAttribute("var-id");
    document.querySelector("#size-options label").click();
    document.querySelectorAll('input[name="quantity"]')[4].click();
    document.querySelector(".size-dropdown").innerText = document.querySelector(
      "#size-options label"
    ).innerText;
    return parseInt(firstvarient);
  }
}

function getCurrentPrice() {
  const variantId = getVariantFromURL();
  if (!variantId) return 0;

  const elements = document.querySelectorAll('input[name="id"]');
  elements.forEach((element) => {
    element.value = variantId;
  });

  // Find the div element with the matching variant ID
  const priceElement = document.querySelector(
    `div[var-id="${variantId}"] span`
  );
  if (!priceElement) return 0;

  // Extract the price from the innerText of the element
  const priceText = priceElement.innerText.trim();
  const regex = /\d+,\d+/g; // Matches prices with commas as decimals
  const matches = priceText.match(regex);

  // If a match is found, replace the comma with a dot for correct parsing
  const priceWithDot = matches ? matches[0].replace(",", ".") : "0";

  return parseFloat(priceWithDot);
}

function populateOptions() {
  const sizeOptions = document.getElementById("size-options");
  const quantityOptions = document.getElementById("quantity-options");

  if (sizeOptions && quantityOptions) {
    data.sizes.forEach((size) => {
      const label = document.createElement("label");
      label.classList.add("size_options");
      label.classList.add("form__label");
      label.innerHTML = `<input type="radio" name="dimensions" value="${size.value}" onchange="toggleCustomSizeInput(this)" data-total="${size.total}" /> ${size.label}`;
      sizeOptions.appendChild(label);
    });

    data.quantities.forEach((quantity, index) => {
      var dynamic_save;
      if (quantity.discount != 0) {
        dynamic_save = `-${quantity.discount}%`;
      } else {
        dynamic_save = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
      }

      const pcsText = quantity.value !== "custom" ? " pcs" : ""; // Conditional check for "pcs"

      const div = document.createElement("div");
      div.innerHTML = `<label class="quantity-options form__label">
                        <div class="quantity-data">
                            <input class="radio-inp" type="radio" name="quantity" value="${quantity.value}" onchange="toggleCustomQuantityInput(this)" /> &nbsp; ${quantity.label}${pcsText}</div>
                        <div class="dynamic_price" data-quantity="${quantity.value}" data-save="${quantity.discount}"></div>
                        <div class="dynamic_sav dynamic_save_${index}" data-save="${quantity.value}">${dynamic_save}</div>
                    </label>`;
      quantityOptions.appendChild(div);
    });

    // Automatically select size and quantity based on URL or localStorage
    const selectedVariantValue = getVariantFromURL();
    const selectedSizeValue = getSizeFromURL() || getSizeFromLocalStorage();
    const selectedQuantityValue =
      getQuantityFromURL() || getQuantityFromLocalStorage();

    if (selectedVariantValue) {
      selectSizeBasedOnVariant(selectedVariantValue);
    }
    if (selectedSizeValue) {
      selectSizeBasedOnValue(selectedSizeValue);
    }
    if (selectedQuantityValue) {
      selectQuantityBasedOnValue(selectedQuantityValue);
    }
  } else {
    console.error("Size options or quantity options element not found.");
  }
}

function getSizeFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  const size = urlParams.get("size");
  return size ? size : null;
}

function getQuantityFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  const quantity = urlParams.get("quantity");
  return quantity ? quantity : null;
}

function getSizeFromLocalStorage() {
  return localStorage.getItem("selectedSize");
}

function getQuantityFromLocalStorage() {
  return localStorage.getItem("selectedQuantity");
}

function saveSizeToLocalStorage(size) {
  localStorage.setItem("selectedSize", size);
}

function saveQuantityToLocalStorage(quantity) {
  localStorage.setItem("selectedQuantity", quantity);
}

function selectSizeBasedOnVariant(variantValue) {
  const sizeRadios = document.querySelectorAll(
    '#size-options input[type="radio"]'
  );
  sizeRadios.forEach((radio) => {
    if (parseInt(radio.getAttribute("data-total")) === variantValue) {
      radio.checked = true;
      toggleCustomSizeInput(radio);
    }
  });
}

function selectSizeBasedOnValue(sizeValue) {
  const sizeRadios = document.querySelectorAll(
    '#size-options input[type="radio"]'
  );
  sizeRadios.forEach((radio) => {
    if (radio.value === sizeValue) {
      radio.checked = true;
      toggleCustomSizeInput(radio);
    }
  });
}

function selectQuantityBasedOnValue(quantityValue) {
  const quantityRadios = document.querySelectorAll(
    '#quantity-options input[type="radio"]'
  );
  quantityRadios.forEach((radio) => {
    if (radio.value === quantityValue) {
      radio.checked = true;
      toggleCustomQuantityInput(radio);
    }
  });
}

const checkbox = document.getElementById("enable_lamination");

function uncheckCheckbox() {
  checkbox.checked = false;
  checkbox.dispatchEvent(new Event("change")); // Trigger change event
  checkbox.setAttribute("name", "properties[Pelliculage]");
}
uncheckCheckbox();

checkbox.addEventListener("change", function () {
  var updatedP = getSizeFromLocalStorage();
  checkbox.setAttribute("name", "properties[Pelliculage]");
  // console.log(updatedP);
  if (this.checked) {
    variantHandler(updatedP);
    document.querySelector("#final-lami").innerHTML = "Oui";
    checkbox.value = "Oui"; // Set value to "Oui" when checked
  } else {
    variantHandler(updatedP);
    document.querySelector("#final-lami").innerHTML = "Non";
    checkbox.value = "Non"; // Set value to "Non" when unchecked
  }
});

// function updatePrice(selectedQuantity) {
//     let price = 0;
//             console.log(data.quantities);

//     if (isNaN(selectedQuantity)) {
//         const selectedQuantityObj = data.quantities.find(quantity => quantity.value === selectedQuantity);

//         if (selectedQuantityObj) {
//             price = selectedQuantityObj.price;
//             document.querySelector("#total-big").innerHTML = selectedQuantityObj.price;;
//         }
//     } else {
//         // Custom pricing logic
//         price = selectedQuantity * getCurrentPrice(); // Example custom pricing logic
//         document.querySelector("#total-big").innerHTML = `€${price.toFixed(2)}`;

//     }
// }

function updatePrice(selectedQuantity) {
  let price = 0;
  let discount = 0;

  if (!isNaN(selectedQuantity)) {
    let basePrice = getCurrentPrice(); // Assuming this function returns the base price

    const selectedQuantityObj = data.quantities.reduce((prev, curr) => {
      return selectedQuantity >= curr.value ? curr : prev;
    });

    // If a valid quantity object is found, apply the discount
    if (selectedQuantityObj) {
      discount = selectedQuantityObj.discount || 0; // Get the discount, default to 0 if undefined
    }

    // Calculate the final price with the discount applied
    let unitPrice = (basePrice * (100 - discount)) / 100;
    unitPrice = Math.ceil(unitPrice * 100) / 100;
    price = selectedQuantity * unitPrice;

    // Update the displayed price
    document.querySelector("#total-big").innerHTML = `€${price.toFixed(2)}`;
  } else {
    // Handle case where selectedQuantity is not a valid number
    document.querySelector("#total-big").innerHTML = "Invalid quantity";
  }
  const quantityElement = document.querySelector(".quantity__input");
  quantityElement.value = selectedQuantity;
  quantityElement.setAttribute("value", selectedQuantity);
  saveQuantityToLocalStorage(selectedQuantity);
}

function variantHandler(sizeValue) {
  let variantInputs = document.querySelectorAll(
    ".product-form__input--pill input"
  );

  if (document.querySelector("#enable_lamination").checked) {
  } else {
    variantInputs = Array.from(variantInputs).filter((input) => {
      return /^\d+$/.test(input.value); // Regular expression to check if the value is only numbers
    });
  }

  if (!variantInputs) {
    // console.error('Variant input elements not found.');
    return;
  }
  let closestSize = null;
  variantInputs.forEach((values) => {
    let dataValue = parseInt(values.value, 10);
    if (
      closestSize === null ||
      (dataValue >= sizeValue &&
        (closestSize < sizeValue || dataValue < closestSize))
    ) {
      closestSize = dataValue;
      // console.log(closestSize,dataValue);
    }
  });

  variantInputs.forEach((values) => {
    let dataValue = parseInt(values.value, 10);
    if (dataValue === closestSize) {
      values.checked = true;
      const radioBtn = document.getElementById(values.id);
      if (radioBtn) {
        radioBtn.checked = true;
        const changeEvent = new Event("change", {
          bubbles: true,
          cancelable: true,
        });
        radioBtn.dispatchEvent(changeEvent);
        radioBtn.click();

        setTimeout(() => {
          const updated_price = getCurrentPrice();
          // console.log(updated_price);
          document
            .querySelectorAll("#quantity-options .dynamic_price")
            .forEach((d) => {
              var prices;

              const previousSibling = d.previousElementSibling;

              if (d.getAttribute("data-save") != 0) {
                var data_save = 100 - d.getAttribute("data-save");
                var discounted_variant_price =
                  (updated_price / 100) * data_save;
                var round_price = Math.ceil(discounted_variant_price * 100) / 100;
                var total_price = (
                  d.getAttribute("data-quantity") * round_price
                ).toFixed(2);

                // console.log(discounted_variant_price);
                if (
                  previousSibling &&
                  previousSibling.classList.contains("quantity-data")
                ) {
                  const radioButton = previousSibling.querySelector(
                    'input[type="radio"]:checked'
                  );
                  if (radioButton) {
                    document.querySelector("#total-big").innerHTML = `€${(
                      d.getAttribute("data-quantity") * round_price
                    ).toFixed(2)}`;
                  }
                  previousSibling
                    .querySelector('input[type="radio"]')
                    .setAttribute(
                      "data-final-price",
                      `€${(
                        d.getAttribute("data-quantity") * round_price
                      ).toFixed(2)}`
                    );
                }

                // <span class="updated_price">€${(d.getAttribute('data-quantity') * updated_price).toFixed(2)}</span>

                prices = `
                            <span class="discounted_price">
                            €${total_price}
                            </span>`;
              } else {
                if (
                  previousSibling &&
                  previousSibling.classList.contains("quantity-data")
                ) {
                  const radioButton = previousSibling.querySelector(
                    'input[type="radio"]:checked'
                  );
                  if (radioButton) {
                    document.querySelector("#total-big").innerHTML = `€${(
                      d.getAttribute("data-quantity") * updated_price
                    ).toFixed(2)}`;
                  }
                  previousSibling
                    .querySelector('input[type="radio"]')
                    .setAttribute(
                      "data-final-price",
                      `€${(
                        d.getAttribute("data-quantity") * updated_price
                      ).toFixed(2)}`
                    );
                }

                prices = `
                               <span class="">€${(
                                 d.getAttribute("data-quantity") * updated_price
                               ).toFixed(2)}</span>
                               <span class="discounted_price">&nbsp;</span>  
                             `;
              }
              d.innerHTML = `
                            <div class="prices">
                             ${prices}
                            </div>                          
                            `;
            });
        }, 100);
      } else {
        console.error("Radio button element not found for id:", values.id);
      }
    }
  });
}

function toggleCustomSizeInput(radio) {
  const customSizeInput = document.getElementById("custom-price-input");
  if (customSizeInput) {
    if (radio.value === "custom") {
      customSizeInput.style.display = "flex";
      var val1 = document.querySelector("#Custom_size1").value;
      var val2 = document.querySelector("#Custom_size2").value;
      radio.setAttribute("data-total", val1 * val2);
      //radio.value = `${val1}x${val2}`;
    } else {
      customSizeInput.style.display = "none";
    }
  } else {
    console.error("Custom size input element not found.");
  }

  const sizeValue = radio.getAttribute("data-total");
  variantHandler(sizeValue);
  saveSizeToLocalStorage(sizeValue);

  document.querySelector("#final-size").innerHTML = `${radio.value} cm`;
  document.querySelector("#final-size-input").value = `${radio.value} cm`;
}

const input1 = document.getElementById("Custom_size1");
const input2 = document.getElementById("Custom_size2");

function validateAndMultiply() {
  if (!input1 || !input2) {
    console.error("Custom size input elements not found.");
    return;
  }

  let value1 = parseFloat(input1.value);
  let value2 = parseFloat(input2.value);
  let err_size = document.getElementById("err_size");
  if (isNaN(value1) || isNaN(value2)) {
    //console.log("Please enter valid numbers.");
    err_size.innerHTML = "Enter height & width";
    return;
  } else {
    err_size.innerHTML = "";
  }
  if (value1 < 2 || value1 > 60 || value2 < 2 || value2 > 60) {
    //console.log("Values must be between 1 and 30.");
    err_size.innerHTML = "La taille doit être comprise entre 2 et 60";
    return;
  } else {
    err_size.innerHTML = "";
  }
  let result = value1 * value2;
  document.querySelector("#final-size").innerHTML = `${value1}x${value2} cm`;
  document.querySelector("#final-size-input").value = `${value1}x${value2} cm`;
  variantHandler(result);
  saveSizeToLocalStorage(result);

  setTimeout(() => {
    const updated_price = getCurrentPrice();
    document
      .querySelectorAll("#quantity-options .dynamic_price")
      .forEach((d) => {
        var prices;

        const previousSibling = d.previousElementSibling;

        if (d.getAttribute("data-save") != 0) {
          var data_save = 100 - d.getAttribute("data-save");
          var discounted_variant_price = (updated_price / 100) * data_save;
          var round_price = Math.ceil(discounted_variant_price * 100) / 100;
          if (
            previousSibling &&
            previousSibling.classList.contains("quantity-data")
          ) {
            const radioButton = previousSibling.querySelector(
              'input[type="radio"]:checked'
            );
            if (radioButton) {
              document.querySelector("#total-big").innerHTML = `€${(
                d.getAttribute("data-quantity") * round_price
              ).toFixed(2)}`;
            }
            previousSibling
              .querySelector('input[type="radio"]')
              .setAttribute(
                "data-final-price",
                `€${(d.getAttribute("data-quantity") * round_price).toFixed(2)}`
              );
          }

          // <span class="updated_price">€${(d.getAttribute('data-quantity') * updated_price).toFixed(2)}</span>
          prices = `
                            <span class="discounted_price">                            
                            €${(
                              d.getAttribute("data-quantity") * round_price
                            ).toFixed(2)}
                            </span>`;
        } else {
          if (
            previousSibling &&
            previousSibling.classList.contains("quantity-data")
          ) {
            const radioButton = previousSibling.querySelector(
              'input[type="radio"]:checked'
            );
            if (radioButton) {
              document.querySelector("#total-big").innerHTML = `€${(
                d.getAttribute("data-quantity") * updated_price
              ).toFixed(2)}`;
            }
            previousSibling
              .querySelector('input[type="radio"]')
              .setAttribute(
                "data-final-price",
                `€${(d.getAttribute("data-quantity") * updated_price).toFixed(
                  2
                )}`
              );
          }

          prices = `
                               <span class="">€${(
                                 d.getAttribute("data-quantity") * updated_price
                               ).toFixed(2)}</span>
                               <span class="discounted_price">&nbsp;</span>  
                             `;
        }
        d.innerHTML = `
                            <div class="prices">
                             ${prices}
                            </div>                          
                            `;
      });
  }, 100);
}

if (input1 && input2) {
  input1.addEventListener("input", validateAndMultiply);
  input2.addEventListener("input", validateAndMultiply);
}

function toggleCustomQuantityInput(radio) {
  let customQuantityInput = document.getElementById("custom-quantity-input");
  let customQuantityText = document.getElementById("custom-quantity-text");
  let quantityInput = document.querySelector(".quantity__input");
  let finalDays = document.getElementById("final-days");

  if (customQuantityInput && quantityInput && finalDays) {
    if (radio.value === "custom") {
      customQuantityInput.style.display = "block";
      customQuantityText.style.display = "block";

      updatePrice(100);
      saveQuantityToLocalStorage(100);
      document.querySelector("#final-qty").innerHTML = 100;
      updateDays(100);
      customQuantityInput.value = 100;
      radio.value = 100;
      const submitButton = document.querySelector(".product-form__submit");

      customQuantityInput.addEventListener("input", function () {
        let quantity = parseInt(customQuantityInput.value);
        radio.value = quantity;
        console.log(radio.value);
        let errorMessage = document.querySelector(".custom-error-msg");

        if (!errorMessage) {
          errorMessage = document.createElement("div");
          errorMessage.classList.add("custom-error-msg");
          errorMessage.style.color = "red"; // Optional styling
          document.querySelector("#custom-quantity-text").before(errorMessage);
        }

        if (quantity < 1 || isNaN(quantity)) {
          errorMessage.style.display = "block"; // Ensure the error message is visible
          errorMessage.innerHTML = "la quantité ne peut pas être négative";
          submitButton.disabled = true;
        } else {
          errorMessage.innerHTML = "";
          errorMessage.style.display = "none"; // Hide the error message
          // quantityInput.value = 100;
          // quantityInput.setAttribute("value", 100);
          saveQuantityToLocalStorage(100);
          document.querySelector("#final-qty").innerHTML = quantity;
          updatePrice(quantity);
          updateDays(quantity);
          submitButton.disabled = false;
        }
      });

      updatePrice(100);
    } else {
      const radioInputs = document.querySelectorAll(".radio-inp");
      const lastRadioInput = radioInputs[radioInputs.length - 1];
      lastRadioInput.value = "custom";

      customQuantityInput.style.display = "none";
      customQuantityText.style.display = "none";
      // quantityInput.value = radio.value;
      // quantityInput.setAttribute("value", radio.value);
      updatePrice(radio.value);
      saveQuantityToLocalStorage(radio.value);
      document.querySelector("#final-qty").innerHTML = radio.value;
      document.querySelector("#total-big").innerHTML =
        radio.getAttribute("data-final-price");
      updateDays(radio.value);
    }
  } else {
    console.error(
      "Custom quantity input, quantity input element, or final days element not found."
    );
  }

  function updateDays(quantity) {
    let days;
    if (quantity < 300) {
      days = 2;
    } else if (quantity < 500) {
      days = 4;
    } else if (quantity < 1000) {
      days = 7;
    } else {
      days = 10;
    }
    finalDays.innerHTML = days + " Jours";
  }
}

document.addEventListener("DOMContentLoaded", populateOptions);

document.addEventListener("DOMContentLoaded", function () {
  var label = document.querySelector('h2[for="additional-text"]');
  var input = document.getElementById("additional-text");
  var previewContainer = document.querySelector(".image-preview-container");
  var previewImage = document.getElementById("image_preview");

  // label.addEventListener('click', function() {
  //     if (input.style.display === 'none' || !input.classList.contains('show')) {
  //         input.style.display = 'block';
  //         setTimeout(function() {
  //             input.classList.add('show');
  //         }, 10);
  //         input.focus();
  //     } else {
  //         input.classList.remove('show');
  //         setTimeout(function() {
  //             input.style.display = 'none';
  //         }, 500);
  //     }
  // });

  document
    .getElementById("custom_photo")
    .addEventListener("change", function (event) {
      const file = event.target.files[0];
      const previewImage = document.getElementById("image_preview"); // Assuming you have an image element with this ID

      if (file) {
        const fileType = file.type;

        if (fileType.startsWith("image/")) {
          // Check if the file is an image
          const reader = new FileReader();
          reader.onload = function (e) {
            previewImage.src = e.target.result;
            previewImage.style.display = "block";
          };
          reader.readAsDataURL(file);
        } else if (fileType === "application/pdf") {
          // Check if it's a PDF file
          previewImage.src =
            "https://cdn.shopify.com/s/files/1/0578/4882/3996/files/80942.png?v=1725791225"; // Set PDF icon
          previewImage.style.display = "block";
        } else {
          // For other non-image and non-PDF files
          previewImage.src =
            "https://cdn.shopify.com/s/files/1/0578/4882/3996/files/page-file-icon.webp?v=1725791274"; // Set default file icon
          previewImage.style.display = "block";
        }
      }
    });

  previewContainer.addEventListener("mouseenter", function () {
    previewImage.style.transform = "scale(1.05)";
  });

  previewContainer.addEventListener("mouseleave", function () {
    previewImage.style.transform = "scale(1)";
  });
});
